<template>
  <div class="Iframe">
    <iframe
      id="frame"
      frameborder="0"
      allow="microphone *;camera *;midi *;encrypted-media *;autoplay *;fullscreen *;display-capture *;"
    ></iframe>
    <!-- 桌面端内且支持安全锁的版本，由于本页面无解锁入口，故需要提供后退按钮 -->
    <el-button
      v-if="$store.state.desktop && $store.state.desktop.deviceInfo"
      class="goBack"
      size="small"
      type="text"
      @click="goBackHandle"
    >
      &lt; 返回
    </el-button>
  </div>
</template>
<script>
export default {
  name: 'Iframe',
  methods: {
    goBackHandle() {
      this.$router.back();
    },
  },
  mounted() {
    this.$nextTick(async () => {
      document.getElementById('frame').src = this.$route.query.url;
    });
  },
};
</script>
<style lang="scss" scoped>
.Iframe {
  iframe {
    width: 100%;
    height: 100vh;
    display: block;
  }
  .goBack {
    position: absolute;
    top: 0;
    padding: 4px 6px;
    color: #666666;
    &:hover {
      color: red;
    }
    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      left: 0;
      background: #000;
      opacity: 0.1;
      border-radius: 4px;
    }
  }
}
</style>
